module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divStyle"
  }, [_c('ul', {
    staticClass: "ulStyle"
  }, _vm._l((_vm.projects), function(project) {
    return (project.category == _vm.projectCategory) ? _c('li', [_c('a', {
      staticClass: "button",
      attrs: {
        "target": "_blank",
        "href": project.url
      }
    }, [(project.url !== '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing"), _c('br'), _vm._v("- or -"), _c('br'), _vm._v("Press to Enter Live Demo Site:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : (project.url === '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(project.headLine00) + " ")]), _vm._v(" "), _c('h2', [_vm._v(" • Front-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine01) + " ")])]), _vm._v(" "), _c('h2', [_vm._v(" • Back-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine02) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "imageContainer lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb.gif")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}_thumb.gif`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb@2x.gif 2x")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])])]) : _vm._e()
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "curriculumSyllabus"
  }, [_c('h1', [_vm._v("Sample Semester Syllabus (Book Reference Upon Request)")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Week 01: Introducing React")]), _vm._v(" "), _c('li', [_vm._v("Week 02: Building Your First React App")]), _vm._v(" "), _c('li', [_vm._v("Week 03: Components in React")]), _vm._v(" "), _c('li', [_vm._v("Week 04: Styling in React")]), _vm._v(" "), _c('li', [_vm._v("Week 05: Creating Complex Components")]), _vm._v(" "), _c('li', [_vm._v("Week 06: Transferring Properties (Props)")]), _vm._v(" "), _c('li', [_vm._v("Week 07: Meet JSX: Part 2")]), _vm._v(" "), _c('li', [_vm._v("Week 08: Dealing with State")]), _vm._v(" "), _c('li', [_vm._v("Week 09: Going from Data to UI")]), _vm._v(" "), _c('li', [_vm._v("Week 10: Working with Events")]), _vm._v(" "), _c('li', [_vm._v("Week 11: The Component Lifecycle")]), _vm._v(" "), _c('li', [_vm._v("Week 12: Accessing DOM Elements")]), _vm._v(" "), _c('li', [_vm._v("Week 13: Creating a Single-Page App Using React Router")]), _vm._v(" "), _c('li', [_vm._v("Week 14: Building a Todo List App")]), _vm._v(" "), _c('li', [_vm._v("Week 15: Setting Up Your React Development Environment")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-776f7182"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkReact.vue
// module id = 125
// module chunks = 1